/* eslint-disable react/prop-types */
import React from 'react';

const SpacerLogKpiCard = ({ label, value, sub, rail = 'neutral', tag, tagClass }) => (
  <div className="spacer-log-kpi-card">
    <div className={`spacer-log-kpi-rail spacer-log-kpi-rail--${rail}`} />
    <span className="spacer-log-kpi-label">{label}</span>
    <span className="spacer-log-kpi-value">{value}</span>
    {sub ? <span className="spacer-log-kpi-sub">{sub}</span> : null}
    {tag ? (
      <span className={`spacer-log-kpi-tag spacer-log-kpi-tag--${tagClass || rail}`}>{tag}</span>
    ) : null}
  </div>
);

export default SpacerLogKpiCard;
